import axios from 'axios'
import dragVerify from 'vue-drag-verify'
import { ClockIcon, EyeIcon, MapIcon } from 'vue-feather-icons'

import AccessQrModal from '@/vcs/_shared/modals/access-qr/cmp.vue'
import backgroundImage from '@/assets/images/locker-bg.svg'
import toastStore from '@/stores/toast-store.js'
import ConfirmationModal from '@/vcs/_shared/modals/confirmation-modal/cmp.vue'
import CollectPackageScreen from '@/vcs/_shared/modals/collect-package-screen/cmp.vue'
import UnassignLockerModal from '@/vcs/_shared/modals/unassign-locker-modal/cmp.vue'
import ChangeLockerModal from '@/vcs/_shared/modals/change-locker-modal/cmp.vue'
import ShowCpModal from '@/vcs/_shared/modals/show-cp-modal/cmp.vue'
import ShowCpMapModal from '@/vcs/_shared/modals/show-cp-map-modal/cmp.vue'

export default {
  name: 'Locker',
  props: {
    locker: Object,
    fetchLockersFn: Function,
  },
  components: {
    ClockIcon,
    EyeIcon,
    MapIcon,
    dragVerify,
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
  data: function () {
    return {
      lockerWidth: 200,
      blocker: false,
      backgroundImage: backgroundImage,
      isSliderVisible: true,
    }
  },
  mounted() {
    this.lockerWidth = this.$refs.locker.offsetWidth - 40
  },
  computed: {
    assignmentExpiresAt() {
      return this.$format(this.locker.boxMembers[0].assignmentExpiresAt, 'DD.MM.YYYY HH:mm')
    },
    isAssignedByAdmin() {
      return this.locker.boxMembers[0].isAssignedByAdmin
    },
    isOnDemand() {
      return this.locker.boxMembers[0].assignmentType == 'on-demand'
    },
  },
  methods: {
    openModal(boxId) {
      this.$store.commit('modal/open', {
        cmp: AccessQrModal,
        animation: 'slide-down-menu',
        data: { boxId: boxId },
      })
    },

    openShowCpModal(boxId, cpId) {
      this.$store.commit('modal/open', {
        cmp: ShowCpModal,
        animation: 'slide-down-menu',
        data: {
          boxId: boxId,
          cpId: cpId,
          type: 'locker',
        },
      })
    },

    openShowCpMapModal(id) {
      this.$store.commit('modal/open', {
        cmp: ShowCpMapModal,
        animation: 'slide-down-menu',
        data: {
          cpId: id,
          type: 'locker',
        },
      })
    },

    openUserBox(boxId, cpId) {
      this.blocker = true
      this.isSliderVisible = false
      axios({
        method: 'put',
        url: `boxes/${this.locker.id}/locker_open`,
      })
        .then(() => {
          this.blocker = false
          this.isSliderVisible = true
          window.mainApp.$emit(`updateLockers`)
          toastStore.commit('success', { message: this.$t('lockers.boxOpen') })

          this.triggerCollectPackageScreenModal(boxId, cpId)
        })
        .catch(error => {
          this.blocker = false
          this.isSliderVisible = true
          window.mainApp.$emit(`updateLockers`)
          this.$errorHumanized({ error })
        })
    },

    triggerCollectPackageScreenModal(boxId, cpId) {
      this.$store.commit('modal/open', {
        cmp: CollectPackageScreen,
        animation: 'slide-down-menu',
        callback: this.collectCallback,
        data: {
          boxId: boxId,
          cpId: cpId,
          type: 'locker',
        },
      })
    },

    collectCallback() {
      window.mainApp.$emit(`updateLockers`)
    },

    confirmAndUnassignLockerOnDemand() {
      this.$store.commit('modal/open', {
        cmp: ConfirmationModal,
        animation: 'slide-down-menu',
        data: {
          text: this.$t('lockerOnDemand.resignButtonText'),
          confirmText: this.$t('yes'),
          cancelText: this.$t('no'),
        },
        callback: () => {
          this.unassignLockerOnDemand()
        },
      })
    },

    unassignLockerOnDemand() {
      this.blocker = true
      axios({
        method: 'put',
        url: `boxes/${this.locker.id}/unassign_on_demand_by_user`,
      })
        .then(response => {
          if (response.status == 200) {
            toastStore.commit('success', { message: 'Success' })

            const boxId = response.data.id
            const cpId = response.data.collectionPoint.id
            this.triggerUnassignLockerModalModal(boxId, cpId)
          }
        })
        .catch(error => {
          this.collectCallback()
          this.$errorHumanized({ error })
        })
        .finally(() => {
          this.blocker = false
        })
    },

    triggerUnassignLockerModalModal(boxId, cpId) {
      this.$store.commit('modal/open', {
        cmp: UnassignLockerModal,
        animation: 'slide-down-menu',
        callback: this.collectCallback,
        data: {
          boxId: boxId,
          cpId: cpId,
          type: 'delivery',
        },
      })
    },

    checkIfChangeLockerOnDemandAvailable() {
      this.blocker = true
      axios({
        method: 'get',
        url: `collection_points/${this.locker.collectionPoint.id}`,
      })
        .then(response => {
          if (response.status == 200) {
            if (response.data.freeBoxesCount != 0) {
              this.$confirm(() => this.unassignLockerOnDemandAndChangeLocker(false))
            } else {
              this.$errorHumanized({
                message:
                  'Na chwilę obecną nie ma innych wolnych lockerów w tym module. Zwolnij locker i zarezerwuj w innym module.',
              })
            }
          }
        })
        .catch(error => {
          this.$errorHumanized({ error })
        })
        .finally(() => {
          this.blocker = false
        })
    },

    unassignLockerOnDemandAndChangeLocker(newLockerSelectable = false) {
      this.blocker = true
      axios({
        method: 'put',
        url: `boxes/${this.locker.id}/unassign_on_demand_by_user`,
      })
        .then(response => {
          if (response.status == 200) {
            toastStore.commit('success', { message: 'Success' })

            const boxId = response.data.id
            const cpId = response.data.collectionPoint.id
            this.triggerChangeLockerModalModal(boxId, cpId, newLockerSelectable)
          }
        })
        .catch(error => {
          this.collectCallback()
          this.$errorHumanized({ error })
        })
        .finally(() => {
          this.blocker = false
        })
    },

    triggerChangeLockerModalModal(boxId, cpId, newLockerSelectable) {
      this.$store.commit('modal/open', {
        cmp: ChangeLockerModal,
        animation: 'slide-down-menu',
        callback: this.collectCallback,
        data: {
          newLockerSelectable: newLockerSelectable,
          boxId: boxId,
          cpId: cpId,
          type: 'delivery',
        },
      })
    },
  },
}
